import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  INotification,
  INotificationCreate,
  IPagedData,
  IPagedSearch,
} from '@evencel/models';
import { Observable } from 'rxjs';

export const NOTIFICATION_URL = 'notifications';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  httpClient = inject(HttpClient);

  post(data: INotificationCreate): Observable<INotification> {
    return this.httpClient.post<INotification>(NOTIFICATION_URL, data);
  }

  patch(data: INotification): Observable<INotification> {
    const url = `${NOTIFICATION_URL}/${data._id}`;
    return this.httpClient.patch<INotification>(url, data);
  }

  delete(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${NOTIFICATION_URL}/${id}`);
  }

  restore(id: string): Observable<void> {
    return this.httpClient.delete<void>(`${NOTIFICATION_URL}/${id}/restore`);
  }

  private searchParams(data: IPagedSearch) {
    const { active, direction } = data.sort;
    const { pageIndex, pageSize } = data.page;
    let params = new HttpParams();
    params = params.append('pageIndex', `${pageIndex}`);
    params = params.append('pageSize', `${pageSize}`);
    params = params.append('sort', active);
    params = params.append('order', direction);
    params = params.append('projection', data.projection || 'dataTable');
    return params;
  }

  search(data: IPagedSearch): Observable<IPagedData<INotification>> {
    const params = this.searchParams(data);
    return this.httpClient.post<IPagedData<INotification>>(
      `${NOTIFICATION_URL}/search`,
      data.condition,
      { params }
    );
  }

  getOne(id: string): Observable<INotification> {
    let params = new HttpParams();
    params = params.append('projection', `form`);
    const url = `${NOTIFICATION_URL}/${id}`;
    return this.httpClient.get<INotification>(url, { params });
  }

  get(data: IPagedSearch): Observable<IPagedData<INotification>> {
    const params = this.searchParams(data);
    return this.httpClient.get<IPagedData<INotification>>(NOTIFICATION_URL, {
      params,
    });
  }
}
